module.exports = __webpack_public_path__ + "static/media/volkswagen-logo.4e94ca48.jpg";